const Client = () => {
  return <></>;
};

export default Client;
